import React from 'react'
import cx from 'classnames'

import Loader from '../../Loader'

import cm from './ToggleContainer.module.css'

export const ToggleContainer = ({
  checked,
  disabled,
  size,
  loading,
}: {
  checked?: boolean
  disabled?: boolean
  size?: 'small' | 'medium'
  loading?: boolean
}) => {
  const hasMediumSize = size === 'medium'
  return (
    <span
      className={cx(cm.toggle, {
        [cm.checked]: checked,
        [cm.disabled]: disabled,
        [cm.medium]: hasMediumSize,
        [cm.loading]: loading,
      })}
    >
      {loading && <Loader size={hasMediumSize ? 20 : 12} className={cm.loader} />}
    </span>
  )
}
